export const faVerticalAlign = {
  verticalAlign: "text-top"
};
